<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy" :total="false"></template-chart>
  </div>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '単価平均', key: 0, align: 'start', calc: 'ave' })
      if (this.item.schools.preschool) {
        if (this.item.schools.extension === 1) {
          temp.push({ title: '幼児単価', key: 1, align: 'start', calc: 'ave' })
          temp.push({ title: '小学部単価', key: 6, align: 'end', calc: 'ave' })
          temp.push({ title: '中学部単価', key: 13, align: 'end', calc: 'ave' })
          temp.push({ title: '高校部単価', key: 17, align: 'end', calc: 'ave' })
        } else {
          temp.push({ title: '幼児単価', key: 1, align: 'start', calc: 'ave' })
          temp.push({ title: '小学部単価', key: 2, align: 'end', calc: 'ave' })
          temp.push({ title: '中学部単価', key: 9, align: 'end', calc: 'ave' })
          temp.push({ title: '高校部単価', key: 13, align: 'end', calc: 'ave' })
        }
      } else {
        temp.push({ title: '小学部単価', key: 1, align: 'end', calc: 'ave' })
        temp.push({ title: '中学部単価', key: 8, align: 'end', calc: 'ave' })
        temp.push({ title: '高校部単価', key: 12, align: 'end', calc: 'ave' })
      }
      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item['calc_fees'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': this.item['calc_fees_sum'][this.yyyy][this.group][2][this.headers[i].key],
          'prefix': '¥',
          'suffix': '',
          'color': '#C8E6C980',
          'calc': 'ave'
        })
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        var id = this.value ? 'calc_fees_diff' : 'calc_fees'
        if (prev >= 2018) {
          for (i in acts) {
            values = this.item[id][prev][this.group].map((v) => {
              return v[acts[i].key]
            })

            prevs.push({
              'key': 'prev' + acts[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              'values': values,
              'sum': this.item[id + '_sum'][prev][this.group][2][this.headers[i].key],
              'prefix': this.value ? '' : '¥',
              'suffix': this.value ? '%' : '',
              'color': '',
              'calc': 'ave'
            })
          }
        }
      }
      var plans = []
      if (this.plan) {
        id = this.value ? 'calc_fees_plans_diff' : 'calc_plans_fees'
        for (i in acts) {
          values = this.item[id][this.yyyy][this.group].map((v) => {
            return v[acts[i].key]
          })

          plans.push({
            'key': 'plans' + acts[i].key,
            'title': this.value ? '目標' : '目標',
            'align': 'end',
            'values': values,
            'sum': this.item[id + '_sum'][this.yyyy][this.group][2][this.headers[i].key],
            'prefix': this.value ? '' : '¥',
            'suffix': this.value ? '%' : '',
            'color': '',
            'calc': 'ave'
          })
        }
      }
      for (i in acts) {
        temp.push(acts[i])
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
        if (plans.length !== 0) {
          temp.push(plans[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
